import { render, staticRenderFns } from "./HighlightedPostItem.vue?vue&type=template&id=56b9216a&scoped=true&"
import script from "./HighlightedPostItem.vue?vue&type=script&lang=js&"
export * from "./HighlightedPostItem.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedPostItem.vue?vue&type=style&index=0&id=56b9216a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9216a",
  null
  
)

export default component.exports